import { Button, ButtonProps } from "@mui/material";
import rumClient, { trackEvent } from "~/utils/monitoring";

interface PreviewButtonProps {
  onOpenPreview: () => void;
  analyticsContext?: {
    dataset_id?: string;
    table_fqn?: string;
  };
  size?: ButtonProps["size"];
}

export function PreviewButton({ onOpenPreview, analyticsContext, size }: PreviewButtonProps) {
  const handleClick = () => {
    if (analyticsContext) {
      trackEvent("dataset_table_preview_clicked", analyticsContext);
    }
    onOpenPreview();
  };

  return (
    <Button variant="outlined" size={size} onClick={handleClick} data-testid="view-data-button">
      View Data
    </Button>
  );
}
